<div class="root" [innerHTML]="content()"></div>
